// Object.fromEntries is not available in older iOS versions
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
export default function fromEntries(entries) {
    return entries.reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
        if (acc.hasOwnProperty(k)) {
            throw new Error("A value for key '".concat(k, "' already exists in the object."));
        }
        acc[k] = v;
        return acc;
    }, {});
}
